<template>
  <div>
    <loading :active.sync="isLoading"
             :is-full-page="fullPage"
             color="green"
             loader="dots"
    ></loading>
    <div class="row">
      <div class="col-md-12 col-12">
        <h3 class="title m-t-10 m-l-15">{{ library ? library.title : '' }}</h3>
        <ol class="breadcrumb" style="margin-top: -20px">
          <li class="breadcrumb-item"><a href="/"><i class="mdi mdi-home"></i> На головну</a></li>
          <li class="breadcrumb-item"><a href="/library/books"><i class="mdi mdi-account-multiple"></i>
            Список книжок</a></li>
          <li class="breadcrumb-item active">Редагування інформації</li>
        </ol>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="row m-3">
          <h4 class="title" v-if="$route.name === 'descriptionCreate'">Нова книга</h4>
          <h4 class="title" v-else>Форма редагування</h4>
        </div>
        <div class="m-3 floating-labels reader-form">
          <div class="row">
            <div class="col-md-3">
              <div class="book-avatar">
                <div v-if="showImage">
<!--                  :data-default-file="'/uploads/' + description.scan_book"-->
                  <input v-if="description.scan_book && !description.cover" type="file" name="photo"
                         class="form-control dropify" data-max-file-size="3M"
                         data-allowed-file-extensions="gif png jpg" data-show-remove="false"
                         style="opacity: 0;" @change="uploadFile"
                         >
                  <input v-else type="file" name="photo" class="form-control dropify"
                         data-show-remove="false" data-allowed-file-extensions="gif png jpg"
                         style="opacity: 0;" @change="uploadFile"
                         data-max-file-size="3M"
                  >
                </div>
                <div class="dropify-wrapper" style="padding: 0" @click="coverHide" v-else>
                  <cover :description="description" :cover="description.cover" @image="coverImage($event)"></cover>
                </div>
              </div>
              <br>
              <br>
              <div class="row">
                <div class="set-size">
                  <div class="pie-wrapper" :class="'progress-' + progress">
                    <span class="label">{{ progress }}<span class="smaller">%</span></span>
                    <div class="pie">
                      <div class="left-side half-circle"></div>
                      <div class="right-side half-circle"></div>
                    </div>
                    <div class="shadow"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-9">
              <div class="row">
                <div class="col-4 form-group">
                  <v-select
                      id="isbn"
                      ref="isbn"
                      :options="listDropDown"
                      :taggable="!listDropDown.some(el => el.name == $refs.isbn.$data.search)"
                      multiple
                      class="form-control"
                      v-model="description.isbn"
                      label="name"
                      @search="getDatalist('isbn',$event)"
                      :loading="selectLoading['isbn']"
                      @search:focus="selectLoading['isbn']=true;getDatalist('isbn', '')"
                      @search:blur="$refs.isbn.$data.search = ''"

                      @input="($event[0] && $event[0].name && $route.name === 'descriptionCreate' && description.isbn.length == 1 ? getISBN($event[0].name ? $event[0].name : $event[0]) : ''); multipleChange('isbn', true); $event.length == 0 ? delete settingsNew['isbn'] : ''"
                      :filterable="false"
                      :class="multiple_show.name == 'isbn' && multiple_show.active == true ? 'active' : ''"
                      @open="multipleChange('isbn', false)"
                      @close="multiple_show.name == 'isbn' && !multiple_show.active ? multipleChange('', false) : ''"
                      @option:created="setSettings($event,'isbn')"
                  >

                    <template #selected-option-container="{option , deselect, multiple, disabled}" v-if="multiple_show.name != 'isbn'">
                                <span style="font-size: 13px; margin: 10px 5px 0 0">
                                  {{ option.name }}{{ description.isbn.length > 1 ? ';' : '' }}
                                </span>
                    </template>
                    <template #spinner="{ loading }">
                      <div v-if="loading" style="border-left-color: rgba(88,151,251,0.71)" class="vs__spinner">
                        The .vs__spinner class will hide the text for me.
                      </div>
                    </template>
                    <template #no-options="{ search, searching, loading }">
                      Категорії не знайдено
                    </template>
                  </v-select>

                  <span class="bar"></span>
                  <label for="isbn" class="floating">ISBN(міжнародний обліковий номер книги)</label>
                </div>
                <div class="col-4">
                  <div class="form-group">
                    <label for="type_record" class="floating">ТИП ЗАПИСУ *</label>
                    <v-select id="type_record"
                              :clearable="false"
                              v-model="description.type_record"
                              :options="listDropDown"
                              label="name"
                              class="form-control static"
                              placeholder=" "
                              required
                              :loading="selectLoading['type_record']"
                              @search="getDatalist('type_record',$event);"
                              :filterable="false"
                              @search:focus="selectLoading['type_record']=true;getDatalist('type_record', '')"
                              ref="type_record_id"
                              :class="errors.hasOwnProperty('type_record_id') ? 'is-invalid' : ''"
                              @input="delete errors.type_record_id;resetPublicationName()"
                              @open="multipleChange('', false)"
                    >
                      <template #no-options="{ search, searching, loading }">
                        Категорії не знайдено
                      </template>
                      <template #spinner="{ loading }">
                        <div v-if="loading" style="border-left-color: rgba(88,151,251,0.71)" class="vs__spinner">
                          The .vs__spinner class will hide the text for me.
                        </div>
                      </template>
                    </v-select>
                    <span class="bar"></span>
                    <div class="invalid-feedback" v-if="errors.hasOwnProperty('type_record_id')">
                      <span v-for="item in errors.type_record_id">{{ item }}</span>
                    </div>
                  </div>
                </div>
                <div class="col-4 text-right">
                </div>
              </div>
              <br>
              <div class="row">
                <div class="col-4">

                  <br>
                  <div class="form-group" style="border-bottom: 1px solid #d9d9d9">
                    <textarea type="text" id="title" required v-model="description.title" class="form-control"
                              ref="title" :class="errors.hasOwnProperty('title') ? 'is-invalid' : ''"
                              @input="delete errors.title" rows="2" style="height: 8.45em"
                              @focus="multipleChange('literature_world', false)"
                    ></textarea>
                    <span class="bar"></span>
                    <label for="title" class="floating">ОСНОВНА НАЗВА *</label>
                    <div class="invalid-feedback" v-if="errors.hasOwnProperty('title')">
                      <span v-for="item in errors.title">{{ item }}</span>
                    </div>
                  </div>
                  <br>
                  <div class="form-group">
                    <label for="author" class="floating">АВТОР</label>
                    <v-select inputId="author"
                              ref="author"
                              v-model="description.author"
                              :options="listDropDown"
                              label="name"
                              class="form-control"
                              placeholder=" "

                              @search:focus="getDatalist('author','')"
                              @search="getDatalist('author',$event)"

                              @search:blur="$refs.author.$data.search = ''"

                              :taggable="!listDropDown.some(el => el.name == $refs.author.$data.search)"

                              :filterable="false"
                              @option:created="setSettings($event,'author', true)"
                              :loading="selectLoading['author']"
                              @input="delete description['author_id']"
                    >
                      <template #no-options="{ search, searching, loading }">
                        Категорії не знайдено
                      </template>
                    </v-select>
                  </div>
                  <br>
                  <div class="form-group">
                    <input type="text" id="author_number" v-model="description.author_number" class="form-control">
                    <span class="bar"></span>
                    <label for="author_number" class="floating">АВТОРСЬКИЙ ЗНАК</label>
                  </div>
                  <br>
                  <div class="form-group">
                    <label for="coauthors" class="floating">СПІВАВТОР / РЕДАКТОР</label>
                    <v-select id="coauthors"
                              ref="coauthors"
                              v-model="description.coauthors"
                              multiple
                              label="name"
                              :options="listDropDown"
                              class="form-control"
                              :class="multiple_show.name == 'coauthors' && multiple_show.active == true ? 'active' : ''"
                              placeholder=" "
                              required
                              @search="getDatalist('coauthors',$event)"
                              :filterable="false"
                              @search:focus="getDatalist('coauthors','')"
                              :taggable="!listDropDown.some(el => el.name == $refs.coauthors.$data.search)"
                              @open="multipleChange('coauthors', true)"
                              @close="multiple_show.name == 'coauthors' && !multiple_show.active ? multipleChange('', false) : ''"
                              @option:created="setSettings($event,'coauthors')"
                              :loading="selectLoading['coauthors']"
                              @search:blur="$refs.coauthors.$data.search = ''"

                    >
                      <template #selected-option-container="{option , deselect, multiple, disabled}" v-if="multiple_show.name != 'coauthors'">
                                <span style="font-size: 13px; margin: 10px 5px 0 0">
                                  {{ option.name }};
                                </span>
                      </template>
                      <template #no-options="{ search, searching, loading }">
                        Категорії не знайдено
                      </template>
                    </v-select>
                  </div>
                  <br>
                  <div class="form-group">
                    <label for="translators" class="floating">АВТОР ПЕРЕКЛАДУ</label>
                    <v-select id="translators"
                              ref="translators"
                              multiple
                              v-model="description.translators"
                              :options="listDropDown"
                              label="name"
                              class="form-control"
                              placeholder=" "
                              required
                              @search="getDatalist('translators',$event)"
                              :filterable="false"
                              @search:focus="getDatalist('translators','')"

                              :taggable="!listDropDown.some(el => el.name == $refs.translators.$data.search)"

                              :class="multiple_show.name == 'translators' && multiple_show.active == true ? 'active' : ''"
                              @open="multipleChange('translators', false)"
                              @input="multipleChange('translators', true)"
                              @close="multiple_show.name == 'translators' && !multiple_show.active? multipleChange('', false) : ''"
                              @option:created="setSettings($event,'translators')"
                              :loading="selectLoading['translators']"
                              @search:blur="$refs.translators.$data.search = ''"

                    >
                      <template #selected-option-container="{option , deselect, multiple, disabled}" v-if="multiple_show.name != 'translators'">
                                                  <span style="font-size: 13px; margin: 10px 5px 0 0">
                                                    {{ option.name }};
                                                  </span>
                      </template>
                      <template #no-options="{ search, searching, loading }">
                        Категорії не знайдено
                      </template>
                    </v-select>
                  </div>
                  <br>
                  <div class="form-group">
                    <label for="illustrators" class="floating">АВТОР ІЛЮСТРАЦІЙ</label>
                    <v-select id="illustrators"
                              ref="illustrators"
                              multiple
                              v-model="description.illustrators"
                              :options="listDropDown"
                              label="name"
                              class="form-control"
                              placeholder=" "
                              required
                              @search="getDatalist('illustrators',$event)"
                              :filterable="false"
                              @search:focus="getDatalist('illustrators','')"
                              :taggable="!listDropDown.some(el => el.name == $refs.illustrators.$data.search)"

                              :class="multiple_show.name == 'illustrators' && multiple_show.active == true ? 'active' : ''"
                              @open="multipleChange('illustrators', false)"
                              @input="multipleChange('illustrators', true)"
                              @close="multiple_show.name == 'illustrators' && !multiple_show.active? multipleChange('', false) : ''"
                              @option:created="setSettings($event,'illustrators')"
                              :loading="selectLoading['illustrators']"
                              @search:blur="$refs.illustrators.$data.search = ''"

                    >
                      <template #selected-option-container="{option , deselect, multiple, disabled}" v-if="multiple_show.name != 'illustrators'">
                            <span style="font-size: 13px; margin: 10px 5px 0 0">
                              {{ option.name }};
                            </span>
                      </template>
                      <template #no-options="{ search, searching, loading }">
                        Категорії не знайдено
                      </template>
                    </v-select>
                  </div>
                  <br>
                  <div class="form-group" v-show="description.type_record && (description.type_record.id == 2 || description.type_record.id == 3 || description.type_record.id == 4)">
                    <label for="publication_name" class="floating">НАЗВА ВИДАННЯ</label>
                    <v-select inputId="publication_name"
                              ref="publication_name"
                              v-model="description.publication_name"
                              :options="listDropDown"
                              label="name"
                              class="form-control"
                              placeholder=" "

                              @search:focus="getDatalist('publication_name','')"
                              @search="getDatalist('publication_name',$event)"

                              @search:blur="$refs.publication_name.$data.search = ''"

                              :taggable="!listDropDown.some(el => el.name == $refs.publication_name.$data.search)"

                              :filterable="false"
                              @option:created="setSettings($event,'publication_name', true)"
                              :loading="selectLoading['publication_name']"
                              @input="delete description['publication_name_id']"
                    >
                      <template #no-options="{ search, searching, loading }">
                        Категорії не знайдено
                      </template>
                    </v-select>
                  </div>

                </div>
                <div class="col-4">
                  <br>
                  <div class="form-group">
                    <label for="rubric" class="floating">ОСНОВНА РУБРИКА*</label>
                    <v-select id="rubric"
                              ref="rubric_id"
                              :clearable="false"
                              v-model="description.rubric"
                              :options="listDropDown"
                              label="name"
                              class="form-control static"
                              placeholder=" "
                              required
                              @search="selectLoading['rubric']=true;getDatalist('rubric',$event)"
                              :filterable="false"
                              @search:focus="getDatalist('rubric', '')"
                              :class="errors.hasOwnProperty('rubric_id') ? 'is-invalid' : ''"
                              @input="delete errors.rubric_id"
                              :loading="selectLoading['rubric']"
                    >
                      <template #spinner="{ loading }">
                        <div v-if="loading" style="border-left-color: rgba(88,151,251,0.71)" class="vs__spinner">
                          The .vs__spinner class will hide the text for me.
                        </div>
                      </template>
                      <template #no-options="{ search, searching, loading }">
                        Категорії не знайдено
                      </template>
                    </v-select>
                    <div class="invalid-feedback" v-if="errors.hasOwnProperty('rubric_id')">
                      <span v-for="item in errors.rubric_id">{{ item }}</span>
                    </div>
                  </div>
                  <br>
                  <div class="form-group">
                    <label for="thematics" class="floating">ТЕМАТИЧНІ РУБРИКИ</label>
                    <v-select id="thematics"
                              ref="thematics"
                              multiple
                              v-model="description.thematics"
                              :options="listDropDown"
                              label="name"
                              class="form-control"
                              placeholder=" "
                              required
                              @search="getDatalist('thematics',$event)"
                              @search:focus="getDatalist('thematics', '')"
                              :taggable="!listDropDown.some(el => el.name == $refs.thematics.$data.search)"

                              :class="multiple_show.name == 'thematics' && multiple_show.active == true ? 'active' : ''"
                              @open="multipleChange('thematics', false)"
                              @input="multipleChange('thematics', true)"
                              @close="multiple_show.name == 'thematics' && !multiple_show.active? multipleChange('', false) : ''"
                              :loading="selectLoading['thematics']"
                              @search:blur="$refs.thematics.$data.search = ''"
                              @option:created="setSettings($event,'thematics')"
                    >
                      <template #selected-option-container="{option , deselect, multiple, disabled}" v-if="multiple_show.name != 'thematics'">
                              <span style="font-size: 13px; margin: 10px 5px 0 0">
                                {{ option.name }};
                              </span>
                      </template>
                      <template #no-options="{ search, searching, loading }">
                        Категорії не знайдено
                      </template>
                    </v-select>
                  </div>
                  <br>
                  <div class="form-group">
                    <label for="key_words" class="floating">КЛЮЧОВІ СЛОВА</label>
                    <v-select id="key_words"
                              ref="key_words"
                              multiple
                              v-model="description.key_words"
                              :options="listDropDown"
                              label="name"
                              class="form-control"
                              placeholder=" "
                              required
                              @search="getDatalist('key_words',$event)"
                              :filterable="false"
                              @search:focus="getDatalist('key_words', '')"
                              :taggable="!listDropDown.some(el => el.name == $refs.key_words.$data.search)"

                              :class="multiple_show.name == 'key_words' && multiple_show.active == true ? 'active' : ''"
                              @open="multipleChange('key_words', false)"
                              @input="multipleChange('key_words', true)"
                              @close="multiple_show.name == 'key_words' && !multiple_show.active? multipleChange('', false) : ''"
                              :loading="selectLoading['key_words']"

                              @search:blur="$refs.key_words.$data.search = ''"
                              @option:created="setSettings($event,'key_words')"

                    >
                      <template #selected-option-container="{option , deselect, multiple, disabled}" v-if="multiple_show.name != 'key_words'">
                                    <span style="font-size: 13px; margin: 10px 5px 0 0">
                                      {{ option.name }};
                                    </span>
                              </template>
                      <template #no-options="{ search, searching, loading }">
                        Категорії не знайдено
                      </template>
                    </v-select>
                  </div>
                  <br>
                  <div class="form-group">
                    <label for="languages" class="floating">МОВА ВИДАННЯ *</label>
                    <v-select id="languages"
                              :filterable="false"
                              multiple
                              v-model="description.languages"
                              :options="listDropDown"
                              label="name"
                              class="form-control static"
                              placeholder=" "
                              required
                              @search="getDatalist('languages',$event)"
                              @search:focus="getDatalist('languages', '')"
                              ref="languages"
                              :class="[errors.hasOwnProperty('languages') ? 'is-invalid' : '', multiple_show.name == 'languages' && multiple_show.active == true ? 'active' : '']"
                              @open="multipleChange('languages', false)"
                              @input="delete errors.languages; multipleChange('languages', true)"
                              @close="multiple_show.name == 'languages' && !multiple_show.active ? multipleChange('', false) : ''">
                      <template #selected-option-container="{option , deselect, multiple, disabled}" v-if="multiple_show.name != 'languages'">
                                <span style="font-size: 13px; margin: 10px 5px 0 0">
                                  {{ option.name }};
                                </span>
                      </template>
                      <template #no-options="{ search, searching, loading }">
                        Категорії не знайдено
                      </template>
                    </v-select>
                    <span class="bar"></span>
                    <div class="invalid-feedback" v-if="errors.hasOwnProperty('languages')">
                      <span v-for="item in errors.languages">{{ item }}</span>
                    </div>
                  </div>
                  <br>
                  <div class="form-group">
                    <label for="count_pages" class="floating">КІЛЬКІСТЬ СТОРІНОК *</label>
                    <input type="number" class="form-control" id="count_pages" v-model="description.count_pages"
                           ref="count_pages" :class="errors.hasOwnProperty('count_pages') ? 'is-invalid' : ''"
                           @input="delete errors.count_pages" @focus="multipleChange('', false)">
                    <span class="bar"></span>
                    <div class="invalid-feedback" v-if="errors.hasOwnProperty('count_pages')">
                      <span v-for="item in errors.count_pages">{{ item }}</span>
                    </div>
                  </div>
                  <br>
                  <div class="form-group">
                    <label for="publication_id" class="floating">ВИДАВНИЦТВО*</label>
                    <v-select
                              :clearable="false"
                              v-model="description.publication"
                              :options="listDropDown"
                              label="name"
                              class="form-control"
                              placeholder=" "
                              required
                              @search="getDatalist('publication',$event)"
                              :filterable="false"
                              @search:focus="getDatalist('publication','')"
                              ref="publication_id"
                              :class="errors.hasOwnProperty('publication_id') ? 'is-invalid' : ''"
                              @input="delete errors.publication; delete description['publication_id']"
                              @open="multipleChange('', false)"
                              :loading="selectLoading['publication']"
                              @search:blur="$refs.publication_id.$data.search = ''"
                              @option:created="setSettings($event,'publication',true)"
                              :taggable="!listDropDown.some(el => el.name == $refs.publication_id.$data.search)"
                    >
                      <template #no-options="{ search, searching, loading }">
                        Категорії не знайдено
                      </template>
                    </v-select>
                  </div>
                  <br>
                  <div class="row">
                    <div class="col-8">
                      <div class="form-group">
                        <label for="location_publication" class="floating">МІСЦЕ ВИДАННЯ*</label>
                        <v-select id="location_publication"
                                  v-model="description.location_publication"
                                  :options="listDropDown"
                                  label="name"
                                  class="form-control"
                                  placeholder=" "
                                  required
                                  @search="getDatalist('location_publication',$event)"
                                  :filterable="false"
                                  @search:focus="getDatalist('location_publication','')"
                                  :taggable="true"
                                  @input="delete errors.location_publication"
                                  :class="errors.hasOwnProperty('location_publication') ? 'is-invalid' : ''"
                                  ref="location_publication"
                                  @option:created="setSettings($event,'location_publication',true)"
                                  @open="multipleChange('', false)"
                                  :reduce="name=>name.name ? name.name : name"
                        >
                          <template #no-options="{ search, searching, loading }">
                            Категорії не знайдено
                          </template>
                        </v-select>
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="form-group">
                        <label for="year" class="floating">РІК ВИДАННЯ*</label>
                        <input type="number" class="form-control" id="year" v-model="description.year" ref="year"
                               required :class="errors.hasOwnProperty('year') ? 'is-invalid' : ''"
                               @input="delete errors.year"
                               @focus="multipleChange('', false)"
                        >
                        <span class="bar"></span>
                      </div>
                    </div>
                  </div>
                  <div class="form-group" style="bottom: 5px" v-if="description.type_record && description.type_record.id == 2">
                    <label for="number_name" class="floatings">НАЙМЕНУВАННЯ НОМЕРУ</label>
                    <input type="text" class="form-control" id="number_name" v-model="description.number_name"
                           @focus="multipleChange('', false)"
                    >
                    <span class="bar"></span>
                  </div>
                  <div class="form-group" style="bottom: 5px" v-if="description.type_record && (description.type_record.id == 3 || description.type_record.id == 4)">
                    <label for="name_parts" class="floatings">НАЙМЕНУВАННЯ ЧАСТИНИ / ТОМУ</label>
                    <input type="text" class="form-control" id="name_parts" v-model="description.name_parts"
                           @focus="multipleChange('', false)"
                    >
                    <span class="bar"></span>
                  </div>
                </div>
                <div class="col-4">
                  <br>
                  <div class="form-group">
                    <v-select id="category_id"
                              v-model="description.category_id"
                              :reduce="text => text.value"
                              :options="categories"
                              @search="$event ? getCategories($event,'title') : getCategories(description.category_id,'id')"
                              @search:focus="getCategories('','title')"
                              :filterable="false"
                              label="text"
                              class="form-control"
                              placeholder="Вибрати категорію"
                              ref="category_id"
                              @input="delete errors.category_id"
                              @close="getCategories(description.category_id,'id')"
                              @open="multipleChange('', false)"
                    >
                      <template #no-options="{ search, searching, loading }">
                        Категорії не знайдено
                      </template>
                    </v-select>
                    <label for="category_id" class="floating">КЛАСИФІКАЦІЯ ЗА УДК</label>
                  </div>
                  <div class="form-group">
                    <label for="udc_add" style="margin: 0">Додати УДК (тільки за відсутності в списку)</label>
                    <div class="row">
                      <div class="col-4" v-if="description.category_id != null">
                        <input type="text" :disabled="description.category_id || description.category_id != ''"
                               class="form-control" id="udc_add" placeholder="Номер УДК"
                               v-model="description.udc_number"
                               @focus="multipleChange('', false)"
                        >
                        <span class="bar"></span>
                      </div>
                      <div class="col-4" v-else>
                        <input type="text" :disabled="description.category_id || description.category_id != null"
                               class="form-control" id="udc_add" placeholder="Номер УДК"
                               v-model="description.udc_number"
                               @focus="multipleChange('', false)"
                        >
                        <span class="bar"></span>
                      </div>
                      <div class="col-8" v-if="description.category_id != ''">
                        <input type="text" :disabled="description.category_id || description.category_id != null"
                               class="form-control" placeholder="Назва УДК"
                               v-model="description.title_udc"
                               @focus="multipleChange('', false)"
                        >
                        <span class="bar"></span>
                      </div>
                      <div class="col-8" v-else>
                        <input type="text" :disabled="description.category_id || description.category_id != ''"
                               class="form-control" placeholder="Назва УДК"
                               v-model="description.title_udc"
                               @focus="multipleChange('', false)"
                        >
                        <span class="bar"></span>
                      </div>
                      <div class="col-12">
                        <div class="invalid-feedback" v-if="errors.hasOwnProperty('category_id')"
                             :style="errors.hasOwnProperty('category_id') ? 'display:block;' : ''">
                          <span v-for="item in errors.category_id">{{ item }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br>
                  <div class="form-group">
                    <label for="index_udc" class="floating">ІНДЕКС ІНШОЇ КЛАСИФІКАЦІЇ</label>
                    <input type="text" class="form-control" id="index_udc" v-model="description.index_udc"
                           @focus="multipleChange('', false)"
                    >
                    <span class="bar"></span>
                    <div class="invalid-feedback" v-if="errors.hasOwnProperty('index_udc')">
                      <span v-for="item in errors.index_udc">{{ item }}</span>
                    </div>
                  </div>
                  <br>
                  <br>
                  <br>
                  <div class="form-group">
                    <label for="circulation" class="floatings">ТИРАЖ / ПРИМІРНИКИ</label>
                    <input type="number" name="circulation" id="circulation" class="form-control"
                           v-model="description.circulation"
                           @focus="multipleChange('', false)"
                    >
                    <span class="bar"></span>
                  </div>
                  <div class="form-group" style="bottom: 5px">
                    <label for="audience" class="floatings">АУДИТОРІЯ</label>
                    <v-select inputId="audience"
                              :searchable="false"
                              v-model="description.audience"
                              :options="listDropDown"
                              @search="getDatalist('audience', $event)"
                              @search:focus="getDatalist('audience', '')"
                              label="name"
                              class="form-control static"
                              placeholder=" "
                              @open="multipleChange('', false)"
                    >
                      <template #no-options="{ search, searching, loading }">
                        Категорії не знайдено
                      </template>
                    </v-select>
                  </div>
                  <br>
                  <br>
                  <div class="form-group" style="bottom: 5px">
                    <b-form-checkbox
                        v-model="description.adult"
                        switch
                        :value="1"
                        :unchecked-value="0"
                        size="switch-size"
                    >{{ description.adult ? 'Страше 18 років' : 'Без обмежень' }}
                    </b-form-checkbox>
                  </div>
                  <div class="form-group" style="bottom: 18px" v-if="description.type_record && description.type_record.id == 2">
                    <label for="count_publication_in_year" class="floatings">КІЛЬКІСТЬ ВИДАНЬ НА РІК</label>
                    <input type="number" class="form-control" id="count_publication_in_year" v-model="description.count_publication_in_year"
                           @focus="multipleChange('', false)"
                    >
                    <span class="bar"></span>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-4 additional" :class="additional_show ? 'additional-show' : ''"
                     @click="additional_show = !additional_show">
                                    <span>
                                        Додаткова інформація
                                    </span>
                </div>
                <div class="col-8">
                  <hr>
                </div>
              </div>
              <br>
              <div v-if="additional_show">
                <div class="row">
                  <div class="col-12">
                    <div class="card covers">
                      <div class="card-body">
                        <div class="row m-3">
                          <div v-for="n in 6" class="col-2 text-center" @click="description.cover = n;coverImage()">
                            <div class="card cover" :style="'background-image: url(/covers/cover-'+n+'.jpg)'">
                            </div>
                            <i class="mdi mdi-check-circle" :class="description.cover == n ? 'check': 'unchek'"></i>
                            <br>
                            <span>Обкладинка {{ n }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <br>
                <div class="row">
                  <div class="col-4">
                    <div class="form-group" style="border-bottom: 1px solid #d9d9d9">
                      <label for="description" class="floatings">КОРОТКИЙ ОПИС</label>
                      <textarea id="description" v-model="description.description" rows="9" ref="description"
                                class="form-control" style="overflow: hidden; height: 15.5em" @click="resizeHeight('description')" @input="resizeHeight('description')" @blur="$refs.description.style.height = '15.5em'" @focus="multipleChange('', false)"
                      ></textarea>
                      <span class="bar"></span>
                    </div>
                    <div class="form-group" style="border-bottom: 1px solid #d9d9d9">
                      <label for="annotation" class="floatings">ЗАГАЛЬНІ ПРИМІТКИ / АНОТАЦІЯ</label>
                      <textarea id="annotation" v-model="description.annotation" rows="2" ref="annotation"
                                class="form-control" style="overflow: hidden;height: 8.8em" @click="resizeHeight('annotation')" @input="resizeHeight('annotation')" @blur="$refs.annotation.style.height = '8.8em'" @focus="multipleChange('', false)"
                      ></textarea>
                      <span class="bar"></span>
                    </div>
                    <div class="form-group" style="border-bottom: 1px solid #d9d9d9">
                      <label for="content" class="floatings">ПРИМІТКИ ПРО ЗМІСТ</label>
                      <textarea id="content" v-model="description.content" rows="4" ref="content"
                                class="form-control" style="overflow: hidden;height: 8.8em" @click="resizeHeight('content')" @input="resizeHeight('content')" @blur="$refs.content.style.height = '8.8em'" @focus="multipleChange('', false)"
                      ></textarea>
                      <span class="bar"></span>
                    </div>

                  </div>
                  <div class="col-4">
                    <div class="form-group">
                      <label for="statements_responsibility" class="floatings">ВІДОМОСТІ ПРО ВІДПОВІДАЛЬНІСТЬ</label>
                      <input id="statements_responsibility" name="statements_responsibility"
                             v-model="description.statements_responsibility" data-style="form-control"
                             class="form-control"
                             @focus="multipleChange('', false)"
                      >
                      <span class="bar"></span>
                    </div>
                    <div class="form-group">
                      <label for="information_publication" class="floatings">ДОДАТКОВІ ВІДОМОСТІ ПРО ВИДАННЯ</label>
                      <input id="information_publication" name="information_publication"
                             v-model="description.information_publication" data-style="form-control"
                             class="form-control"
                             @focus="multipleChange('', false)"
                      >
                      <span class="bar"></span>
                    </div>
<!--                    <div class="form-group">-->
<!--                      <label for="number_parts" class="floatings">НОМЕР ЧАСТИНИ</label>-->
<!--                      <input type="text" class="form-control" id="number_parts" v-model="description.number_parts"-->
<!--                             @focus="multipleChange('', false)"-->
<!--                      >-->
<!--                      <span class="bar"></span>-->
<!--                    </div>-->

<!--                    <div class="form-group">-->
<!--                      <label for="purpose_volume" class="floatings">ПРИЗНАЧЕННЯ ТОМУ</label>-->
<!--                      <input type="text" class="form-control" id="purpose_volume" v-model="description.purpose_volume"-->
<!--                             @focus="multipleChange('', false)"-->
<!--                      >-->
<!--                      <span class="bar"></span>-->
<!--                    </div>-->
                    <div class="form-group">
                      <label for="language_original" class="floatings">МОВА ОРИГІНАЛУ</label>
                      <v-select id="language_original"
                                v-model="description.language_original"
                                :options="listDropDown"
                                label="name"
                                class="form-control"
                                placeholder=" "
                                required
                                @search:focus="getDatalist('language_original','')"
                                @open="multipleChange('', false)"
                      >
                        <template #no-options="{ search, searching, loading }">
                          Категорії не знайдено
                        </template>
                      </v-select>
                    </div>
                    <div class="form-group">
                      <label for="placename" class="floatings">ГЕОГРАФІЧНА НАЗВА</label>
                      <v-select id="placename"
                                multiple
                                v-model="description.placename"
                                :options="listDropDown"
                                label="name"
                                class="form-control"
                                placeholder=" "
                                required
                                @search="getDatalist('placename',$event)"
                                :filterable="false"
                                @search:focus="getDatalist('placename','')"
                                :taggable="true"
                                @option:created="setSettings($event,'placename')"
                                :class="multiple_show.name == 'placename' && multiple_show.active == true ? 'active' : ''"
                                @open="multipleChange('placename', false)"
                                @input="multipleChange('placename', true)"
                                @close="multiple_show.name == 'placename' && !multiple_show.active ? multipleChange('', false) : ''"
                                :reduce="name=>name.name ? name.name : name"
                      >
                        <template #selected-option-container="{option , deselect, multiple, disabled}" v-if="multiple_show.name != 'placename'">
                                <span style="font-size: 13px; margin: 10px 5px 0 0">
                                  {{ option.name }};
                                </span>
                        </template>
                        <template #no-options="{ search, searching, loading }">
                          Категорії не знайдено
                        </template>
                      </v-select>
                    </div>
                    <div class="form-group">
                      <label for="literature_world" class="floatings">ЛІТЕРАТУРА КРАЇН СВІТУ</label>
                      <v-select id="literature_world"
                                multiple
                                v-model="description.literature_world"
                                :options="listDropDown"
                                label="name"
                                class="form-control"
                                placeholder=" "
                                required
                                @search="getDatalist('literature_world',$event)"
                                :filterable="false"
                                @search:focus="getDatalist('literature_world','')"
                                :taggable="true"
                                @option:created="setSettings($event,'literature_world')"
                                :class="multiple_show.name == 'literature_world' && multiple_show.active == true ? 'active' : ''"
                                @open="multipleChange('literature_world', false)"
                                @input="multipleChange('literature_world', true)"
                                @close="multiple_show.name == 'literature_world' && !multiple_show.active ? multipleChange('', false) : ''"
                                :reduce="name=>name.name ? name.name : name"
                      >
                        <template #selected-option-container="{option , deselect, multiple, disabled}" v-if="multiple_show.name != 'literature_world'">
                                <span style="font-size: 13px; margin: 10px 5px 0 0">
                                  {{ option.name }};
                                </span>
                        </template>
                        <template #no-options="{ search, searching, loading }">
                          Категорії не знайдено
                        </template>
                      </v-select>
                    </div>
                    <div class="form-group">
                      <label for="literature_periods" class="floatings">ЛІТЕРАТУРА ЗА ПЕРІОДАМИ</label>
                      <v-select id="literature_periods"
                                multiple
                                v-model="description.literature_periods"
                                :options="listDropDown"
                                label="name"
                                class="form-control"
                                placeholder=" "
                                required
                                @search="getDatalist('literature_periods',$event)"
                                :filterable="false"
                                @search:focus="getDatalist('literature_periods','')"
                                :taggable="true"
                                @option:created="setSettings($event,'literature_periods')"
                                :class="multiple_show.name == 'literature_periods' && multiple_show.active == true ? 'active' : ''"
                                @open="multipleChange('literature_periods', false)"
                                @input="multipleChange('literature_periods', true)"
                                @close="multiple_show.name == 'literature_periods' && !multiple_show.active ? multipleChange('', false) : ''"
                                :reduce="name=>name.name ? name.name : name"
                      >
                        <template #selected-option-container="{option , deselect, multiple, disabled}" v-if="multiple_show.name != 'literature_periods'">
                                <span style="font-size: 13px; margin: 10px 5px 0 0">
                                  {{ option.name }};
                                </span>
                        </template>
                        <template #no-options="{ search, searching, loading }">
                          Категорії не знайдено
                        </template>
                      </v-select>
                    </div>
                    <div class="form-group">
                      <label for="series" class="floatings">ВНУТРІШНЯ СЕРІЯ</label>
                      <v-select id="series"
                                ref="series"
                                multiple
                                v-model="description.series"
                                :options="listDropDown"
                                label="name"
                                class="form-control"
                                placeholder=" "
                                required
                                @search="getDatalist('series',$event)"
                                :filterable="false"
                                @search:focus="getDatalist('series','');multipleChange('series', true)"
                                :taggable="true"
                                @option:created="setSettings($event,'series')"
                                :class="multiple_show.name == 'series' && multiple_show.active == true ? 'active' : ''"

                                @close="multipleChange('', false)"
                                :reduce="name=>name.name ? name.name : name"
                                @search:blur="$refs.series.$data.search = ''"

                      >
                        <template #selected-option-container="{option , deselect, multiple, disabled}" v-if="multiple_show.name != 'series'">
                                <span style="font-size: 13px; margin: 10px 5px 0 0">
                                  {{ option.name }};
                                </span>
                        </template>
                        <template #no-options="{ search, searching, loading }">
                          Категорії не знайдено
                        </template>
                      </v-select>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="form-group">
                      <label for="book_format" class="floatings">ФОРМАТ ВИДАННЯ</label>
                      <v-select id="book_format"
                                :searchable="false"
                                v-model="description.book_format"
                                :options="listDropDown"
                                @search:focus="getDatalist('book_format', '')"
                                @search="getDatalist('book_format', $event)"
                                label="name"
                                class="form-control static"
                                placeholder=" "
                                @open="multipleChange('', false)"
                      >
                        <template #no-options="{ search, searching, loading }">
                          Категорії не знайдено
                        </template>
                      </v-select>
                    </div>
                    <div class="form-group">
                      <label for="illustration" class="floatings">ІЛЮСТРАЦІЇ</label>
                      <v-select id="illustration"
                                :searchable="false"
                                v-model="description.illustration"
                                :options="listDropDown"
                                @search:focus="getDatalist('illustration', '')"
                                @search="getDatalist('illustration', $event)"
                                label="name"
                                class="form-control static"
                                placeholder=" "
                                @open="multipleChange('', false)"
                      >
                        <template #no-options="{ search, searching, loading }">
                          Категорії не знайдено
                        </template>
                      </v-select>
                    </div>
                    <div class="form-group">
                      <label for="binding" class="floatings">ПАЛІТУРКА</label>
                      <v-select id="binding"
                                :searchable="false"
                                v-model="description.binding"
                                :options="listDropDown"
                                @search="getDatalist('binding', $event)"
                                @search:focus="getDatalist('binding', '')"
                                label="name"
                                class="form-control static"
                                placeholder=" "
                                @open="multipleChange('', false)"
                      >
                        <template #no-options="{ search, searching, loading }">
                          Категорії не знайдено
                        </template>
                      </v-select>
                    </div>
                    <div class="form-group">
                      <label for="paper" class="floatings">ПАПІР</label>
                      <v-select id="paper"
                                :searchable="false"
                                v-model="description.paper"
                                :options="listDropDown"
                                @search:focus="getDatalist('paper', '')"
                                @search="getDatalist('paper', $event)"
                                label="name"
                                class="form-control static"
                                placeholder=" "
                                @open="multipleChange('', false)"
                      >
                        <template #no-options="{ search, searching, loading }">
                          Категорії не знайдено
                        </template>
                      </v-select>
                    </div>

                    <div class="row">
                      <div class="col-6">
                        <div class="form-group">
                          <label for="size_book" class="floatings">РОЗМІР</label>
                          <input id="size_book" name="size_book" v-model="description.size_book"
                                 class="form-control"
                                 @focus="multipleChange('', false)"
                          >
                          <span class="bar"></span>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="form-group">
                          <label for="weight_book" class="floatings">ВАГА</label>
                          <input name="weight_book" id="weight_book"
                                 v-model="description.weight_book" class="form-control"
                                 @focus="multipleChange('', false)"
                          >
                          <span class="bar"></span>
                        </div>
                      </div>
                    </div>

                    <div class="form-group">
                      <label for="code_book" class="floatings">ШТРИХ-КОД КНИГИ</label>
                      <input name="code_book" id="code_book" v-model="description.code_book"
                             class="form-control"
                             @focus="multipleChange('', false)"
                      >
                      <span class="bar"></span>
                    </div>
                    <div class="form-group">
                      <label for="codes_self_index" class="floatings">ШИФРИ / ПОЛИЧНИЙ ІНДЕКС</label>
                      <input name="codes_self_index" id="codes_self_index"
                             class="form-control" v-model="description.codes_self_index"
                             @focus="multipleChange('', false)"
                      >
                      <span class="bar"></span>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="form-group float-sm-right m-b-40 m-r-15" id="save-cancel">
          <div  class="btn btn-outline-secondary btn-lg mt-auto mb-auto" style="padding: 14px">
            <a :href="description.id ? '/library/description/' + description.id : '/library/books'"
               style="font-size: 15px;">
              <i class="mdi mdi-close-circle"></i> Скасувати
            </a>
          </div>
          <button @click="saveBook" class="btn btn-success btn-lg m-l-20" type="submit" style="font-size: 15px"><i
              class="mdi mdi-check-circle"></i> Зберегти
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cover from "./Cover";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import _ from 'lodash'
export default {
  name: "DescriptionBookCreateEdit",
  components: {Cover,Loading},
  data() {
    return {
      library:null,
      isLoading:false,
      fullPage: true,
      selectLoading:[],
      multiple_show: {
        active:false,
        name:''
      },
      errors: {},
      categories: [],
      description: {
        isbn: [],
        category_id: '',
        index_udc:'',
        title: '',
        author: '',
        author_number: '',
        type_record:'',
        rubric:'',
        languages: '',
        publication: '',
        year: '',
        location_publication: '',
        coauthors: [],
        translators: [],
        illustrators: [],
        count_pages: '',
        adult: '',
        description: '',
        annotation:'',
        content:'',
        key_words: [],
        thematics: [],
        information_publication: '',
        series: [],
        literature_world: '',
        literature_periods: '',
        placename: '',
        language_original: '',
        audience: '',
        illustration: '',
        // book_format_id:'',
        book_format: '',
        binding: '',
        paper: '',
        size_book: '',
        weight_book: '',
        code_book: '',
        circulation: '',
        codes_self_index: '',
        cover: null,
        scan_book: '',
        udc_number: '',
        title_udc: '',
        // collection:'',
        number_parts:'',
        name_parts:'',
        // purpose_volume:'',
        statements_responsibility:'',
        publication_name:'',
        number_name:'',
        count_publication_in_year:''
      },
      showImage: true,
      additional_show: false,
      listDropDown: [],
      settingsNew: {},
    }
  },
  computed: {
    progress: function () {
      let progress = 0;
      let length = 36;
      for (const [key, value] of Object.entries(this.description)) {
        if (this.description[key] !== '' && this.description[key] !== null && this.description[key].length > 0) {
          progress++;
        }
        // length++;
      }
      return (progress / length * 100).toFixed(0);
    },
  },
  mounted() {
    if(this.$route.query.status === 'create'){
      this.getDescription(this.$route.query.id);
    }else if (this.$route.name != 'descriptionCreate') {
      this.getDescription();
    } else {

      this.showImage = true;
      this.$nextTick(function () {

        $('input.dropify').dropify({
          messages: {
            'default': '',
            'replace': 'Перетягніть файл<br>або натиснить для зміни',
            'remove': 'Видалити',
            'error': 'Уууупс, щось пішло не так.'
          },
          error: {
            'fileSize': 'Перевищено максимальны розмір файла ({{ value }} макс).',
            'minWidth': 'Ширина зображення занадто мала ({{ value }}}px мін).',
            'maxWidth': 'Ширина зображення занадто велика ({{ value }}}px макс).',
            'minHeight': 'Висота зображення занадто мала ({{ value }}}px мін).',
            'maxHeight': 'Висота зображення занадто велика ({{ value }}px макс).',
            'imageFormat': 'Обраний тип файла не підтримується ({{ value }}).'
          },
          tpl: {
            wrap: '<div class="dropify-wrapper"></div>',
            loader: '<div class="dropify-loader"></div>',
            message: '<div class="dropify-message"><span class="mdi mdi-cloud-upload" /> <p class="text-center">{{ default }}</p></div>',
            preview: '<div class="dropify-preview" style="padding: 0px"><span class="dropify-render"></span><div class="dropify-infos"><div class="dropify-infos-inner"><p class="dropify-infos-message">{{ replace }}</p></div></div></div>',
            filename: '<p class="dropify-filename"><span class="file-icon"></span> <span class="dropify-filename-inner"></span></p>',
            clearButton: '<button type="button" class="dropify-clear">{{ remove }}</button>',
            errorLine: '<p class="dropify-error text-center">{{ error }}</p>',
            errorsContainer: '<div class="dropify-errors-container"><ul></ul></div>'
          }
        });
      });
      this.getLibrary();
    }
  },
  updated() {
    let preview = '<div class="dropify-preview" style="padding: 0px"><span class="dropify-render"></span><div class="dropify-infos"><div class="dropify-infos-inner"><p class="dropify-infos-message">{{ replace }}</p></div></div></div>';
    if(this.description.scan_book != null){
      preview = '<div class="dropify-preview" style="padding: 0px;display: block"><span class="dropify-render"><img src="/uploads/' + this.description.scan_book + '"></span><div class="dropify-infos"><div class="dropify-infos-inner"><p class="dropify-infos-message">{{ replace }}</p></div></div></div>';
    }
    this.$nextTick(() => {
      $('input.dropify').dropify({
        messages: {
          'default': '',
          'replace': 'Перетягніть файл<br>або натиснить для зміни',
          'remove': 'Видалити',
          'error': 'Уууупс, щось пішло не так.'
        },
        error: {
          'fileSize': 'Перевищено максимальны розмір файла ({{ value }} макс).',
          'minWidth': 'Ширина зображення занадто мала ({{ value }}}px мін).',
          'maxWidth': 'Ширина зображення занадто велика ({{ value }}}px макс).',
          'minHeight': 'Висота зображення занадто мала ({{ value }}}px мін).',
          'maxHeight': 'Висота зображення занадто велика ({{ value }}px макс).',
          'imageFormat': 'Обраний тип файла не підтримується ({{ value }}).'
        },
        tpl: {
          wrap: '<div class="dropify-wrapper"></div>',
          loader: '<div class="dropify-loader"></div>',
          message: '<div class="dropify-message"><span class="mdi mdi-cloud-upload" /> <p class="text-center">{{ default }}</p></div>',
          preview: preview,
          filename: '<p class="dropify-filename"><span class="file-icon"></span> <span class="dropify-filename-inner"></span></p>',
          clearButton: '<button type="button" class="dropify-clear">{{ remove }}</button>',
          errorLine: '<p class="dropify-error text-center">{{ error }}</p>',
          errorsContainer: '<div class="dropify-errors-container"><ul></ul></div>'
        }
      });
    });
  },
  methods: {
    resetPublicationName(){
      this.description.publication_name = '';
      this.description.publication_name_id = '';
      this.description.name_parts = '';
      this.description.number_name = '';
      this.description.count_publication_in_year = '';
    },
    selectAutoComplete(field){
      if(!this.description[field]){
        this.description[field] = [];
      }
      if(this.$refs[field].$data.search != '' && !this.description[field].some(el=>el == this.$refs[field].$data.search || el.name == this.$refs[field].$data.search)){

        if(!this.$refs[field].$props.taggable){
          this.description[field].push(this.listDropDown[0]);
        }else{
          this.description[field].push(this.$refs[field].$data.search);
          this.setSettings(this.$refs[field].$data.search,field)
        }
      }
      this.$refs[field].$data.search = '';

    },
    resizeHeight(el){
      this.$refs[el].style.height = this.$refs[el].scrollHeight + "px";
    },
    multipleChange(name,active){
        this.multiple_show.name = name;
        this.multiple_show.active = active;
    },
    setSettings(event, field, single = false) {
        if(typeof this.settingsNew[field] != 'undefined' && !single){
          this.settingsNew[field].push(event.name ? event.name : event);
        }else{
          this.settingsNew[field] = [event];
        }
    },
    uploadFile(event) {
      this.description.scan_book = event.target.files[0];
      this.description.cover = null;
    },
    coverImage(event = null) {
      this.showImage = false;

      if (event) {
        this.showImage = true;

        this.description.scan_book = event;

        this.$nextTick(function () {

          $('input.dropify').dropify({
            messages: {
              'default': '',
              'replace': 'Перетягніть файл<br>або натиснить для зміни',
              'remove': 'Видалити',
              'error': 'Уууупс, щось пішло не так.'
            },
            error: {
              'fileSize': 'Перевищено максимальны розмір файла ({{ value }} макс).',
              'minWidth': 'Ширина зображення занадто мала ({{ value }}}px мін).',
              'maxWidth': 'Ширина зображення занадто велика ({{ value }}}px макс).',
              'minHeight': 'Висота зображення занадто мала ({{ value }}}px мін).',
              'maxHeight': 'Висота зображення занадто велика ({{ value }}px макс).',
              'imageFormat': 'Обраний тип файла не підтримується ({{ value }}).'
            },
            tpl: {
              wrap: '<div class="dropify-wrapper"></div>',
              loader: '<div class="dropify-loader"></div>',
              message: '<div class="dropify-message"><span class="mdi mdi-cloud-upload" /> <p class="text-center">{{ default }}</p></div>',
              preview: '<div class="dropify-preview" style="padding: 0px;display: block"><span class="dropify-render"><img src="' + URL.createObjectURL(event) + '"></span><div class="dropify-infos"><div class="dropify-infos-inner"><p class="dropify-infos-message">{{ replace }}</p></div></div></div>',
              filename: '<p class="dropify-filename"><span class="file-icon"></span> <span class="dropify-filename-inner"></span></p>',
              clearButton: '<button type="button" class="dropify-clear">{{ remove }}</button>',
              errorLine: '<p class="dropify-error text-center">{{ error }}</p>',
              errorsContainer: '<div class="dropify-errors-container"><ul></ul></div>'
            }
          });
        });
      }

    },
    coverHide() {
      this.showImage = true;
      this.description.cover = null;

      this.$nextTick(function () {
        $('input.dropify').dropify({
          messages: {
            'default': '',
            'replace': 'Перетягніть файл<br>або натиснить для зміни',
            'remove': 'Видалити',
            'error': 'Уууупс, щось пішло не так.'
          },
          error: {
            'fileSize': 'Перевищено максимальны розмір файла ({{ value }} макс).',
            'minWidth': 'Ширина зображення занадто мала ({{ value }}}px мін).',
            'maxWidth': 'Ширина зображення занадто велика ({{ value }}}px макс).',
            'minHeight': 'Висота зображення занадто мала ({{ value }}}px мін).',
            'maxHeight': 'Висота зображення занадто велика ({{ value }}px макс).',
            'imageFormat': 'Обраний тип файла не підтримується ({{ value }}).'
          },
          tpl: {
            wrap: '<div class="dropify-wrapper"></div>',
            loader: '<div class="dropify-loader"></div>',
            message: '<div class="dropify-message"><span class="mdi mdi-cloud-upload" /> <p class="text-center">{{ default }}</p></div>',
            preview: '<div class="dropify-preview" style="padding: 0px"><span class="dropify-render"></span><div class="dropify-infos"><div class="dropify-infos-inner"><p class="dropify-infos-message">{{ replace }}</p></div></div></div>',
            filename: '<p class="dropify-filename"><span class="file-icon"></span> <span class="dropify-filename-inner"></span></p>',
            clearButton: '<button type="button" class="dropify-clear">{{ remove }}</button>',
            errorLine: '<p class="dropify-error text-center">{{ error }}</p>',
            errorsContainer: '<div class="dropify-errors-container"><ul></ul></div>'
          }
        });
      });
    },
    saveBook() {
      this.isLoading = true;
      let form = new FormData();
      let url;
      if (this.$route.name === 'descriptionCreate') {
        url = '/library/books';
      } else {
        form.append('_method', 'put');
        url = '/library/description/' + this.description.id;
      }
      if (!this.description.cover) {
        this.description.cover = Math.random() * (6 - 1) + 1
      }
      for (let item in this.description) {
        if (Array.isArray(this.description[item])) {
          if(this.description[item].length > 0){
            if(item == 'placename' || item == 'series' || item == 'literature_world' || item == 'literature_periods'){
              let str = '';
              this.description[item].forEach((el,index)=>{
                str += el + (this.description[item].length == index + 1 ? '' : ',');
              });
              form.append(item,str);
            }else{
              this.description[item].forEach(el=>{
                if(el.id){
                  form.append(item + '[]', el.id);
                }
              });
            }
          }else{
            if(item == 'placename' || item == 'series' || item == 'literature_world' || item == 'literature_periods') {
              form.append(item,'');
            }else if(item != 'languages'){
              form.append(item, '[]');
            }
          }
        }else if (typeof this.description[item] === 'object' && this.description[item] != null && item != 'scan_book'){
          if(this.description[item].id){
            form.append(item+'_id',  this.description[item].id);
          }else{
            form.append(item,  this.description[item].id);
          }
          delete this.description[item+'_id'];
        }else if(
            (this.description[item] == null || Object.keys(this.description[item]).length === 0) && (
            item == 'audience' ||
            item == 'publication_name' ||
            item == 'binding' ||
            item == 'book_format' ||
            item == 'type_record' ||
            item == 'illustration' ||
            item == 'paper' ||
            item == 'author' ||
            item == 'publication' ||
            item == 'language_original' ||
            item == 'rubric')
        ){
          form.append(item+'_id',  '');
          delete this.description[item+'_id'];
        }else if(this.description[item] === '') {
          form.append(item, '');
        } else if(this.description[item] == null) {
          form.append(item, '');
        }else{
          if(item == 'category_id' || item.indexOf('_id') == -1){
            form.append(item, this.description[item]);
          }
        }
      }

      for (let item in this.settingsNew) {
        for(let value in this.settingsNew[item]){
          form.append('settingsNew[' + item + '][]', this.settingsNew[item][value].name ? this.settingsNew[item][value].name :this.settingsNew[item][value]);
        }
      }
      this.$nextTick(() => {
        axios.post(url, form).then(response => {
          window.location.href = '/library/description/' + response.data;
        }).catch(error => {
          this.isLoading = false;
          if(error.response.data.errors){
            this.errors = error.response.data.errors;
          }
          for (let item in this.errors) {
            if (typeof this.$refs[item].name === 'string') {
              this.$refs[item].focus();
            } else {
              this.$refs[item].$refs.search.focus()
            }
            break;
          }
        });
      });
    },
    getISBN(value, blur = false) {
        this.showImage = false;
        this.isLoading = true;

        axios.get('/library/isbn?value='+value).then(response => {
          if (response.data) {
            if(response.data.param == 'edit'){
              window.location.href = '/library/description/' + response.data.description.id;
            } else if(response.data.param == 'redirect'){
              window.location.href = '/library/description/' + response.data.description.id;
            }else if(response.data.param == 'create'){
              if(response.data.description.length == 0){
                let isbn = this.description.isbn;
                this.description = response.data.description;
                this.description.isbn = isbn;
              }else{
                this.description = response.data.description;
              }

              delete this.description.id;
              this.getCategories(this.description.category_id,'id');
              this.showImage = true;

              this.isLoading = false;
            }
          }
        });
    },
    getDatalist:_.debounce(function (field, title) {
      // this.selectLoading[field] = true;
      let type_record = null;
      if(field == 'publication_name'){
        type_record = this.description.type_record.id;
      }
      this.listDropDown = [];
      axios.get('/library/settings?field=' + field + (title != '' ? '&name=' + title : '') + (type_record != null ? '&type_record_id=' + type_record : '')).then(response => {
        this.listDropDown = response.data.data.map(el => {
            return el;
        });
        this.selectLoading = [];
      });
    },250),
    getCategories(event, type) {
      axios.get('/library/categories?' + type + '=' + event).then(response => {
        this.categories = response.data.data;
      });
    },
    getLibrary(){
      axios.get('/library').then(res => {
        this.library = res.data;
      }).catch(error => {
        this.library = {title:'Адмін Панель'};
      })
    },
    getDescription(id = null) {

      axios.get(id ? '/library/description/' + id : this.$route.path).then(response => {
        this.description = response.data.description;
        this.additional_show = true;
        //TODO нужно будет в будущем убрать
        if (this.description.description === 'default') {
          this.description.description = '';
        }
        //TODO end
        if (this.description.cover && !this.description.scan_book) {
          this.showImage = false;
        } else {
          this.showImage = true;
        }
        this.getCategories(response.data.description.category_id, 'id');
        this.getLibrary();
      });
    }
  },
}
</script>

<style>
textarea.form-control {
  height: 16.3em;
  resize: none;
  /*color: #9E9E9E;*/
  font-size: 13px;
  line-height: 22px;
  border: none !important;
  margin-bottom: 10px
}

.tags {
  color: #9E9E9E;
  font-size: 13px;
  background-color: #DFE6F0;
}

.tags button {
  padding: 0 2px 0 2px;
  font-size: 13px !important;
  color: #DFE6F0 !important;
  background-color: #FE9780;
}

.static .mdi.mdi-menu-down {
  color: #5C6F7C;
}
.mdi.mdi-menu-down{
  color: #A7AFBA;
}

.custom-switch.b-custom-control-switch-size .custom-control-label {
  font-size: 13px;
  padding: 5px 0 0 15px;
}

.custom-switch.b-custom-control-switch-size .custom-control-label::before {
  height: 26px;
  width: 43px;
  border-radius: 16px;
  padding-right: 10px;
}

.custom-switch.b-custom-control-switch-size .custom-control-label::after {
  height: 20px;
  width: 20px;
  border-radius: 50%;
  top: calc(0.3rem + 2px);
  left: calc(-2rem + 2px);
}
</style>

<style scoped>
.form-control >>> .vs__open-indicator{
  transition: unset;
}
.form-control >>> .vs__dropdown-toggle,
.form-control >>> .vs__dropdown-menu {
  font-size: 13px;
  border: none;
}

.form-control >>> .vs__actions {
  padding: 0;
  margin-right: -5px;
  align-items: unset;
}
.form-control >>> input.vs__search{
  padding: 0px;
}

.form-control >>> .vs__search,
.form-control >>> .vs__selected {
  font-size: 13px;
  color: #414141;
  white-space: unset;
  padding: 5px;
  margin: 10px 5px 0 0 !important;
}

.form-group >>> .v-select{
  height: 40px;
  overflow: hidden;
}
.form-group >>> .v-select.vs--single:hover{
  overflow: unset;
}
.form-group >>> .v-select.vs--single .vs__selected-options .vs__selected{
  padding: 0;
  white-space: nowrap;
  width: 90%;
}
.form-group >>> .v-select.active,
/*.form-group >>> .v-select:hover,*/
.form-group >>> .v-select:focus-within {
  height: unset;
  overflow: unset;
}

.form-group >>>.vs__selected-options {
  width: 90%;
  overflow: hidden;
  padding: 0;
}

.form-control {
  min-height: 40px;
  color: #414141;
}

input {
  font-size: 13px;
}

.add-book {
  width: 200px;
  height: 60px;
  position: relative;
  bottom: 50px;
  background-color: #DFE6F0;
  font-size: 15px;
}

.add-book.show {
  background-color: #64BB88;
}
</style>

